<template>
  <div>
    <div class="top">
      <h3>{{time}}</h3>
      <p>{{today}}</p>
    </div>
    <div class="top-center">
      <div class="content">
        <div class="icon"></div>
        <h3>购票成功</h3>
        <p>您【{{detail.t_date}} {{detail.time_period}}】的参观订单已经支付成功，请在下方出票口取走纸质票，凭纸质票检票参观。</p>
      </div>

      <div class="btn-group">
        <div class="back-btn" @click="goBack">继续购票</div>
        <div class="ok" @click="goHome">返回首页{{times}}</div>
      </div>
    </div>

    <div class="footer">
      <p>
        <!-- 设备ID：{{deviceId}} -->
        <span class="tel">
          客服电话
          <span>25650850 25650860</span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { setInterval, clearInterval, setTimeout } from "timers";
export default {
  name: "HelloWorld",
  data() {
    return {
      deviceId: localStorage.deviceNum || "123456789",
      time: "",
      today: "",
      day: "",
      timer: "",
      week: "",
      times: 60,
      timer2: "",
      detail: {
        time_period: "",
        t_date: ""
      },
      order_id: ""
    };
  },
  created() {
    var that = this;
    this.order_id = this.$route.query.order_id;

    this.timer2 = setInterval(() => {
      this.times = this.times >= 1 ? this.times - 1 : 0;
      if (this.times == 0) {
        clearInterval(that.timer2);
        that.$router.replace("/");
      }
    }, 1000);
  },
  mounted() {
    this.getDay();
    var that = this;
    this.$once("hook:beforeDestroy", function() {
      clearInterval(that.timer2);
      clearInterval(that.timer);
    });
    var t_date = this.$route.query.t_date;
    var time_period = this.$route.query.time_period;
    var type = this.$route.query.type;
    if (type == 1) {
      setTimeout(() => {
        this.$router.replace("/nopage");
      }, 1500);
    }
    if (t_date) {
      this.detail.t_date = t_date;
      this.detail.time_period = time_period;
    }
    if (this.order_id) {
      this.getOrder();
    }
    if (this.timer == "") {
      this.timer = setInterval(() => {
        this.getDay();
      }, 10000);
    }
  },
  methods: {
    getOrder() {
      this.$api.TicketInfo(this.order_id).then(res => {
        this.detail = res.data;
      });
    },
    goHome() {
      
      this.$router.replace("/");
    },
    goBack() {
      this.$router.replace("/ticket_buy");
    },
    getDay() {
      var day = new Date();
      var hours = day.getHours();
      hours = hours < 10 ? "0" + hours : hours;
      var min = day.getMinutes();
      min = min < 10 ? "0" + min : min;
      var month = day.getMonth() + 1;
      var days = day.getDate();
      var week = day.getDay();
      var strWeek = "";
      var weeks = "";
      switch (week) {
        case 0:
          strWeek = "星期日";
          weeks = "周日";
          break;
        case 1:
          strWeek = "星期一";
          weeks = "周一";
          break;
        case 2:
          strWeek = "星期二";
          weeks = "周二";
          break;
        case 3:
          strWeek = "星期三";
          weeks = "周三";
          break;
        case 4:
          strWeek = "星期四";
          weeks = "周四";
          break;
        case 5:
          strWeek = "星期五";
          weeks = "周五";
          break;
        case 6:
          strWeek = "星期六";
          weeks = "周六";
          break;
      }
      this.time = hours + ":" + min;
      this.day = month + "月" + days + "日 ";
      this.today = month + "月" + days + "日 " + strWeek;
      this.week = weeks;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  width: 100%;
  min-height: 1920px;
  height: 1920px;
  background: #f0f0f0;
  overflow: hidden;
  position: relative;
  padding-bottom: 165px;

  .top {
    padding: 68px 50px;
    color: #4d4d4d;
    font-size: 25px;
    height: 486px;
    position: relative;
    h3 {
      font-size: 70px;
      margin: 0;
    }
    .title {
      position: absolute;
      top: 100px;
      left: 55%;
      transform: translateX(-50%);
      font-size: 50px;
      font-weight: 500;
      letter-spacing: 3px;
    }
  }
  .titles {
    font-size: 60px;
    letter-spacing: 3px;
    color: #0c5193;
    text-align: left;
    margin: 85px 60px 50px;
  }
  .top-center {
    padding: 60px 50px;
    margin-top: -300px;
    position: relative;
    h3 {
      color: #005192;
      font-size: 50px;
      margin-bottom: 40px;
    }
    .content {
      background: #fff;
      position: relative;
      margin: 182px 0 160px;
      height: 648px;
      border-radius: 14px;
      border: 1px solid #005192;
      position: relative;
      margin-bottom: 80px;
      .icon {
        width: 112px;
        height: 112px;
        background: url(.././assets/ok.png) no-repeat;
        background-size: cover;
        margin: 135px auto 40px;
      }
      h3 {
        color: #000;
        font-size: 36px;
        text-align: center;
        margin-bottom: 56px;
        font-weight: 500;
      }
      p {
        font-size: 30px;
        color: #000;
        text-align: center;
        margin: 0 auto 48px;
        width: 900px;
        line-height: 50px;
      }
    }
  }
}
.btn-group {
  margin: 160px auto 0;
  .back-btn {
    display: block;
    width: 670px;
    height: 98px;
    border: 1px solid #b95020;
    color: #fff;
    background: #b95020;
    border-radius: 49px;
    font-size: 30px;
    font-weight: 600;
    line-height: 96px;
    text-align: center;
    cursor: pointer;
    margin: 0 auto 56px;
    letter-spacing: 3px;
  }
  .ok {
    width: 670px;
    height: 98px;
    border: 1px solid #b95020;
    line-height: 98px;
    color: #b95020;
    font-size: 30px;
    border-radius: 49px;
    text-align: center;
    cursor: pointer;
    margin: 0 auto;
    letter-spacing: 3px;
  }
}
.back {
  width: 213px;
  height: 98px;
  line-height: 98px;
  box-shadow: 0px 4px 13px 0px rgba(185, 32, 80, 0.35);
  border-radius: 49px 0px 0px 49px;
  background: #fff;
  color: #b95020;
  font-size: 30px;
  text-align: center;
  position: fixed;
  top: 35%;
  right: 0;
  z-index: 998;
  font-weight: 500;
}
.footer {
  position: absolute;
  bottom: 0;
  padding: 60px;
  left: 0;
  font-size: 24px;
  width: 100%;
  p {
    color: #5a5a5a;
    font-size: 20px;
    overflow: hidden;
    vertical-align: middle;
    .tel {
      float: right;
      color: #1c78f7;
      font-size: 20px;
      display: inline-block;
      vertical-align: middle;
      span {
        margin-left: 10px;
        font-size: 34px;
        font-weight: 800;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Ticket_Success.vue